import React, { useEffect } from "react";
import { Button, Card, Col } from "react-bootstrap";
import { AddWorldWide, DeleteHighScore } from "../modals/allModal";
import useDialogState from "../../hooks/useDialog";
import { ContinentTable } from "../allTables/allTable";
import { useFormik } from "formik";
import * as yup from "yup";
import * as XLSX from "xlsx";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import HighScoreService from "../../services/hiscore.service";

const schema = yup.object().shape({
  data: yup.mixed().required("Please Upload Your Data"),
});

const Antarctica = () => {
  const location = useLocation();
  const selectedType = location.search.split("=")[1];
  const [data, setData] = useState([]);
  const [worldWide, setWorldWide] = useState("");
  const [totalAfrica, setTotalAfrica] = useState("");
  const [totalAntarctica, setTotalAntarctica] = useState("");
  const [totalAsia, setTotalAsia] = useState("");
  const [totalEurope, setTotalEurope] = useState("");
  const [totalNorthamerica, setTotalNorthamerica] = useState("");
  const [totalOceania, setTotalOceania] = useState("");
  const [totalSouthamerica, setTotalSouthamerica] = useState("");
  const [deleteHighScore, setDeleteHighScore] = useState(false);
  const handleHighScoreClose = () => setDeleteHighScore(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const {
    open: modalShow,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();

  const getAllHighScore = async (page) => {
    setIsLoading(true);
    try {
      const response = await HighScoreService.GetHighScore(
        "Middle East",
        search,
        page,
        dataPerPage,
        selectedType.toUpperCase()
      );
      setData(response.data.data);
      setWorldWide(response.data.totalWorldWidecount);
      setTotalAfrica(response.data.totalAfrica);
      setTotalAntarctica(response.data.totalAntarctica);
      setTotalAsia(response.data.totalAsia);
      setTotalEurope(response.data.totalEurope);
      setTotalNorthamerica(response.data.totalNorthamerica);
      setTotalOceania(response.data.totalOceania);
      setTotalSouthamerica(response.data.totalSouthamerica);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getAllHighScore();
  }, [pageNumber, dataPerPage, search]);

  const initialValue = {
    data: "",
  };

  const submit = async (values, action) => {
    try {
      setLoader(true);
      const data = { 
        ...values,
        typeScore: selectedType.toUpperCase(),
      };
      await HighScoreService.CreateHighScore(data);
      setLoader(false);
      handleDialogClose();
      getAllHighScore();
      action.resetForm();
      enqueueSnackbar("Data Uplaod Succesfully", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Invalid Data Uplaod", {
        variant: "error",
      });
      setLoader(false);
    }
  };

  const handleOpen = async () => {
    handleDialogOpen();
    formik.setFieldValue("type", "Middle East");
    formik.setFieldValue("data", "");
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const handlePageChange = async (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    await getAllHighScore(newPageNumber);
    setIsLoading(false);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];

    if (!file || !file.name.endsWith(".xlsx")) {
      enqueueSnackbar(
        "Invalid File Type! Only Excel files (XLSX) are allowed.",
        {
          variant: "error",
        }
      );
      return;
    }

    const reader = new FileReader();

    reader.onload = async function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      formik.setFieldValue("data", sheetData);
    };

    reader.readAsArrayBuffer(file);
  };
  const handleDelete = () => {
    setDeleteHighScore(true);
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card
            className="custom-card pointer"
            onClick={() => {
              navigate(`/highscore?type=${selectedType}`);
            }}>
            <Card.Body
              style={{ backgroundColor: "#fff", borderRadius: "11px" }}>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  World Wide
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="mdi mdi-web icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{worldWide}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card
            className="custom-card pointer"
            onClick={() => {
              navigate(`/highscore/europe?type=${selectedType}`);
            }}>
            <Card.Body
              style={{ backgroundColor: "#fff", borderRadius: "11px" }}>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Europe
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fas fa-flag icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalEurope}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card
            className="custom-card pointer"
            onClick={() => {
              navigate(`/highscore/asia?type=${selectedType}`);
            }}>
            <Card.Body
              style={{ backgroundColor: "#fff", borderRadius: "11px" }}>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Asia
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fa fa-globe icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalAsia}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col sm={12} md={6} lg={6} xl={3}>
          <Card
            className="custom-card pointer"
            onClick={() => {
              navigate(`/highscore/africa?type=${selectedType}`);
            }}>
            <Card.Body
              style={{ backgroundColor: "#fff", borderRadius: "11px" }}>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Africa
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fas fa-flag icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalAfrica}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col sm={12} md={6} lg={6} xl={3}>
          <Card
            className="custom-card pointer"
            onClick={() => {
              navigate(`/highscore/northAmerica?type=${selectedType}`);
            }}>
            <Card.Body
              style={{ backgroundColor: "#fff", borderRadius: "11px" }}>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  North America
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fas fa-flag icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalNorthamerica}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col sm={12} md={6} lg={6} xl={3}>
          <Card
            className="custom-card pointer"
            onClick={() => {
              navigate(`/highscore/southamerica?type=${selectedType}`);
            }}>
            <Card.Body
              style={{ backgroundColor: "#fff", borderRadius: "11px" }}>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  South America
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fas fa-flag icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalSouthamerica}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col sm={12} md={6} lg={6} xl={3}>
          <Card
            className="custom-card pointer"
            onClick={() => {
              navigate(`/highscore/middleEast?type=${selectedType}`);
            }}>
            <Card.Body
              style={{ backgroundColor: "#6259ca", borderRadius: "11px" }}>
              <div className="card-order ">
                <label
                  className="main-content-label font-weight-bold mb-3 pt-1"
                  style={{ color: "#fff" }}>
                  Middle East
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fas fa-flag icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalAntarctica}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card
            className="custom-card pointer"
            onClick={() => {
              navigate(`/highscore/oceania?type=${selectedType}`);
            }}>
            <Card.Body
              style={{ backgroundColor: "#fff", borderRadius: "11px" }}>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Oceania
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fas fa-flag icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalOceania}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col sm={12} md={6} lg={6} xl={3} className="ms-auto mt-auto">
          <div
            className="custom-card text-end  pointer"
            style={{ marginRight: "18px" }}>
            <div style={{ display: "flex", justifyContent: "end" }}>
              {totalAntarctica === 0 && (
                <>
                  <Button className="text-white" onClick={() => handleOpen("")}>
                    <i className="fas fa-plus"></i> &nbsp; Add Middle East List
                  </Button>
                  <AddWorldWide
                    show={modalShow}
                    onHide={handleDialogClose}
                    formik={formik}
                    loader={loader}
                    type="Middle East"
                    showFileToSingleUpload={handleFileUpload}
                  />
                </>
              )}
              {totalAntarctica !== 0 && (
                <>
                  <Button
                    className="text-white"
                    variant="danger"
                    style={{ marginBottom: "5px", marginLeft: "15px" }}
                    onClick={() => handleDelete("")}>
                    <i className="fas fa-trash"></i> &nbsp; Delete All Data
                  </Button>
                  {deleteHighScore && (
                    <DeleteHighScore
                      show={deleteHighScore}
                      onHide={handleHighScoreClose}
                      getAllHighScore={getAllHighScore}
                      type="Middle East"
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </Col>
      </div>
      <ContinentTable
        totalRows={totalAfrica}
        handleSearchData={(e) => setSearch(e.target.value)}
        data={data}
        dataPerPage={dataPerPage}
        handlePageChange={handlePageChange}
        isLoading={isLoading}
        setDataPerPage={setDataPerPage}
        getAllHighScore={getAllHighScore}
        type="Middle East"
      />
    </>
  );
};

export default Antarctica;
